
import { Toast } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { ChangeByPhone } from "@/req/password"
import NavBar from "./header.vue"
@Component({
  components: {
    NavBar
  }
})
export default class Logout extends Vue {
  public passwordShow = false;
  public btnBgc = false;
  public formLogin = {
          password: '',
          newPassword: '',
        }
  // public validatePass: any = (rule, value, callback) => {
  //     if (value !== this.formLogin.password) {
  //       callback(new Error("两次输入密码不一致"));
  //     } else {
  //       callback();
  //     }
  //   };
   // 表单效验规则
  public loginFormRules = {
            password: [
              { required: true},
              { pattern: /^[\S]{6,20}$/ }
            ],
            newPassword: [
              { required: true},
              // { validator: this.validatePass, trigger: "blur", required: true}
            ],
          }

  public async onSubmit() {
    if (this.formLogin.password !== this.formLogin.newPassword) {
      Toast("两次输入密码不一致");
      return;
    }
    const obj = {
      phone: this.$route.params.phone,
      code: this.$route.params.code,
      newpassword: this.formLogin.password,
      repassword: this.formLogin.newPassword
    }
    const res = await ChangeByPhone(obj);
    if (res.code === 200) {
      this.$router.push('/login');
    } else {
      Toast(res.msg);
    }
  }
  public onChange() {
    if (this.formLogin.password === "" || this.formLogin.newPassword === "") {
        this.btnBgc = false;
    } else {
        this.btnBgc = true;
    }
  }
}
